var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_4723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0182 7.88419C26.0182 7.88419 25.7616 6.07231 24.9711 5.27672C23.9702 4.22963 22.8513 4.2245 22.338 4.1629C18.6629 3.896 13.1451 3.896 13.1451 3.896H13.1349C13.1349 3.896 7.61709 3.896 3.942 4.1629C3.42872 4.2245 2.30977 4.22963 1.30887 5.27672C0.518414 6.07231 0.266906 7.88419 0.266906 7.88419C0.266906 7.88419 0 10.0143 0 12.1393V14.1308C0 16.2558 0.261773 18.3859 0.261773 18.3859C0.261773 18.3859 0.518414 20.1978 1.30373 20.9934C2.30463 22.0405 3.61863 22.0046 4.20377 22.1175C6.30823 22.3177 13.14 22.3793 13.14 22.3793C13.14 22.3793 18.6629 22.369 22.338 22.1072C22.8513 22.0456 23.9702 22.0405 24.9711 20.9934C25.7616 20.1978 26.0182 18.3859 26.0182 18.3859C26.0182 18.3859 26.28 16.2609 26.28 14.1308V12.1393C26.28 10.0143 26.0182 7.88419 26.0182 7.88419ZM10.4247 16.5484V9.16226L17.5234 12.8682L10.4247 16.5484Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_4723"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.28,
    height: 26.28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialYoutube);
export default __webpack_public_path__ + "static/media/social-youtube.277d81eeab88c1f8ac3040464145dfa9.svg";
export { ForwardRef as ReactComponent };